import React from "react";
import { useHistory } from "react-router-dom";
import * as Path from "routes/paths";
import { IMG_LOGO_1, MAIN_LOGO_DUMMY_ } from "utils/constant";
import ReactPagination from "components/shared/ReactPagination";
import { itemsPerPage, PAGE_LIMIT_TRADE } from "helpers/viewContent";
import { DATE_FORMAT_TIME_ } from "helpers/common";

// {
//   "_id": "680f31e7123c5d284eb87a02",
//     "method": "POST",
//       "endpoint": "/api/v1/tradingApis/deleteAllOrders",
//         "statusCode": 5003,
//           "responseTimeMs": 1338,
//             "createdAt": "2025-04-28T07:44:39.972Z"
// },

export default ({
  userListing,
  setFilter,
  filter,
  userPermissions,
}) => {
  const history = useHistory();
  //pagination
  const handlePageChange = (page) => {
    setFilter({
      ...filter,
      page: page,
    });
    window.scrollTo(0, 0);
  };

  const indexOfLastItem = filter?.page * PAGE_LIMIT_TRADE;
  const indexOfFirstItem = indexOfLastItem - PAGE_LIMIT_TRADE;

  const currentItems =
    userListing?.length > 0 &&
    userListing?.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <div className="row mt-3">
      <div className="col-md-12">
        <div className="card graph_card">
          <div className="card-body">
            <div class="table-responsive">
              <table className="table common_tabel_th">
                <thead>
                  <tr>
                    <th> Method </th>
                    <th> Endpoint </th>
                    <th> Status Code </th>
                    <th> Response Time (Ms) </th>
                    <th> Created At </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.length > 0 ?
                    (currentItems.map((list, i) => {
                      return (
                        <tr
                          title="view"
                          className="cursor-pointer"
                        >
                          <td className="d-flex align-items-center">
                            {list.method
                              || "N/A"}
                          </td>
                          <td>{list.endpoint.replace("/api/v1/tradingApis", "")
                            || "N/A"}</td>
                          <td>
                            {list.statusCode
                              || "N/A"}
                          </td>
                          <td>{`${list?.responseTimeMs} ms`}</td>
                          <td>{DATE_FORMAT_TIME_(list?.createdAt)}</td>
                        </tr>
                      );
                    })) :
                    <tr>
                      <td colSpan={5} className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};
